import { createFileRoute, redirect } from "@tanstack/react-router";
const SLUG = "foam-roof-problems-phoenix-normal-vs-repair";
export const Route = createFileRoute("/foam-roof-problems-phoenix-normal-vs-repair")({
  beforeLoad: () => { throw redirect({ to: "/blog/$slug", params: { slug: SLUG }, statusCode: 301 }); },
});
